<template>
  <v-container>
    <v-checkbox v-model="showActive" label="Show only Active Challenges" />
    <v-data-table
      :headers="headers"
      :items="corporateChallenges"
      :items-per-page="60"
      dense
      :loading="loading"
      class="mt-2 elevation-2"
    >
      <template v-slot:item.title="{ item }">
        <router-link class="black--text font-weight-bold" :to="`/reporting/corporate/${item.id}`">
          {{ item.title }}
        </router-link>
      </template>
      <template v-slot:item.startDate="{ item }">
        {{ item.startDate | moment("ddd, D MMM YY") }}
      </template>
      <template v-slot:item.endDate="{ item }">
        {{ item.endDate | moment("ddd, D MMM YY") }}
      </template>

      <template v-slot:item.engagedUsersRollingWeek="{ item }">
        {{ item.numberOfUsers > 0 ? ((item.engagedUsersRollingWeek / item.numberOfUsers) * 100).toFixed(2) : 0 }}
      </template>

      <template v-slot:item.engagedUsersRollingMonth="{ item }">
        {{ item.numberOfUsers > 0 ? ((item.engagedUsersRollingMonth / item.numberOfUsers) * 100).toFixed(2) : 0 }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { CORPORATE_WITH_ENGAGMENT_QUERY } from "@/graphql/queries/corporate";

export default {
  name: "CorporateListing",
  data() {
    return {
      loading: false,
      showActive: false,
      headers: [
        { text: "Corporate", value: "title" },
        { text: "Users", value: "numberOfUsers" },
        { text: "Start date", value: "startDate" },
        { text: "End date", value: "endDate" },
        { text: "Engagment for the last week rolling", value: "engagedUsersRollingWeek" },
        { text: "Engagment for the last month rolling", value: "engagedUsersRollingMonth" },
      ],
    };
  },
  apollo: {
    corporateChallenges: {
      query: CORPORATE_WITH_ENGAGMENT_QUERY,
      variables() {
        return {
          active: this.showActive,
        };
      },
      fetchPolicy: "cache-and-network",
    },
  },
};
</script>
